var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagType,_vm._g(_vm._b({tag:"component",class:[
    "cv-switcher-item-link",
    (_vm.carbonPrefix + "--switcher__item-link"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--switcher__item-link--selected")] = _vm.selected, _obj ) ]},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }